module.exports = __webpack_public_path__ + "static/img/featured-bg.8a9b4d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/featured-bg.jpg
// module id = wMU8
// module chunks = 7